import { Eyebrow } from '../concept/eyebrow';

/**
 * The concept's content header: eyebrow, name, one meta line, actions right.
 * On phone the actions wrap under the name rather than squeezing the title.
 */
export const PageHeader: React.FC<{
  eyebrow: string;
  title: string;
  meta?: string;
  actions?: React.ReactNode;
}> = ({ eyebrow, title, meta, actions }) => (
  <header className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between sm:gap-4">
    <div className="min-w-0">
      <Eyebrow>{eyebrow}</Eyebrow>
      {/* Desktop only: there is no top bar above lg, so this is where the
          name lives. Below lg the top bar already carries it, and printing it
          twice pushed the first real card off the fold. */}
      <h1 className="mt-2 hidden truncate text-2xl font-semibold tracking-[-0.025em] lg:block">
        {title}
      </h1>
      {meta && <p className="tabular mt-1 text-xs text-foreground-soft">{meta}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </header>
);
